<template>
  <div id="modal-export " class="modal-export" v-if="modalVisible">
    <div class="modal-overlay " @click="closeModalExport">
      <div class="modal-data" @click="displayPicker = false">
        <div class="row-1">
          <div class="column-1" v-if="embedUrlData">
            <div class="  iframe">
              <iframe-component :embed="embedUrlData"></iframe-component>
            </div>
          </div>
          <div class="column-2">
            <div class=" items links ">
              <!--items links-->
              <div class="tab-data ">
                <button
                  v-bind:class="{ active: isActiveComponent }"
                  class=""
                  v-on:click="openTab('ListComponents')"
                >
                  {{ textes.integrations }}
                </button>
                <!--<button   v-bind:class="{'active':isActiveSocial}"  v-on:click="openTab('ListSocialMedia')"> Réseaux sociaux</button>-->
              </div>

              <div class=" items links" v-show="listComponent">
                <!--items links-->
                <div class="" v-if="!(isLive || interactions.length === 0)">
                  <p style="text-align: left; font-weight: bold;">
                    {{ textes.integrations_options }}
                  </p>
                </div>
                <div class="link-interaction" v-if="!(isLive || interactions.length === 0)">
                  <div class="interactions">
                    <interaction-component
                      v-for="(interaction, index) in interactionsData"
                      :key="index"
                      :interaction.sync="interaction"
                    ></interaction-component>
                  </div>
                </div>

                <div class="link-data" v-if="uid">
                  <p style=" font-weight: bold;">UID</p>

                  <p style="word-break: break-all;">{{ uid }}</p>

                  <input ref="uidInput" type="hidden" :value.sync="uid" />
                  <button
                    :class="['linkButton', { 'is-copied': copieduid }]"
                    @click="copyText('uidInput', 'uid')"
                  >
                    <font-awesome-icon
                      :icon="{ prefix: 'fas', iconName: 'check' }"
                      class=" check-icon"
                      v-if="copieduid"
                    />
                    <span v-else>{{ textes.copy }}</span>
                  </button>
                </div>
                <div class="link-data" v-if="mp4">
                  <p style=" font-weight: bold;">MP4</p>
                  <p style="word-break: break-all;" v-html="mp4Text"></p>
                  <input ref="mp4Input" type="hidden" :value.sync="mp4Text" />
                  <button
                    :class="['linkButton', { 'is-copied': copiedmp4 }]"
                    @click="copyText('mp4Input', 'mp4')"
                  >
                    <font-awesome-icon
                      :icon="{ prefix: 'fas', iconName: 'check' }"
                      class=" check-icon"
                      v-if="copiedmp4"
                    />
                    <span v-else>{{ textes.copy }}</span>
                  </button>

                  <!--font-awesome-icon @click="copie" icon="copy" class="icon-copy"/--->
                </div>
                <div class="link-data" v-if="telechargement">
                  <p style=" font-weight: bold;">{{ textes.downloads }}</p>
                  <p style="word-break: break-all;">{{ telechargement }}</p>
                  <input ref="telInput" type="hidden" :value.sync="telechargement" />
                  <button
                    :class="['linkButton', { 'is-copied': copiedtel }]"
                    @click="copyText('telInput', 'telechargement')"
                  >
                    <font-awesome-icon
                      :icon="{ prefix: 'fas', iconName: 'check' }"
                      class=" check-icon"
                      v-if="copiedtel"
                    />
                    <span v-else>{{ textes.copy }}</span>
                  </button>
                  <!--font-awesome-icon @click="copie" icon="copy" class="icon-copy"/-->
                </div>
                <div class="link-data auto-play-container" v-if="embedUrl">
                  <p style=" font-weight: bold;">
                    {{ textes.start_video_auto }}
                  </p>
                  <div class="link-p">
                    <div class="toggle-switch-container">
                      <label class="switch">
                        <input type="checkbox" v-model="autoPlay" @change="updateEmbedCode" />
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="link-data color-container" v-if="embedUrl">
                  <p style=" font-weight: bold;">
                    {{ textes.default_color }}
                  </p>
                  <div class="link-p" @click.stop="">
                    <div
                      class="bg-color-area"
                      :style="'background-color: ' + color"
                      @click.stop="displayPicker = !displayPicker"
                    ></div>
                    <chrome-picker
                      v-show="displayPicker"
                      :disableAlpha="true"
                      v-model="colors"
                      @input="updateEmbedCode"
                    ></chrome-picker>
                  </div>
                </div>

                <div class="link-data start-at-container" v-if="embedUrl && !isLive">
                  <p style=" font-weight: bold;">{{ textes.start_at }}</p>
                  <div class="link-p">
                    <input
                      class="time-input"
                      v-model="startAt.min"
                      type="text"
                      placeholder="00"
                      @keyup="timeValidate('min')"
                    />
                    <b>m</b>
                    <input
                      class="time-input"
                      v-model="startAt.sec"
                      type="text"
                      placeholder="00"
                      @keyup="timeValidate('sec')"
                    />
                    <b>s</b>
                  </div>
                </div>

                <div class="link-data" v-if="embedUrlPer">
                  <p style=" font-weight: bold;">{{ textes.permalink }}</p>
                  <p class="link-p">{{ embedUrlDataPer }}</p>

                  <input type="hidden" ref="linkEmbedPer" :value.sync="embedUrlDataPer" />
                  <button
                    :class="['linkButton', { 'is-copied': copiedper }]"
                    @click="copie('linkEmbedPer', 'permalien')"
                  >
                    <font-awesome-icon
                      :icon="{ prefix: 'fas', iconName: 'check' }"
                      class=" check-icon"
                      v-if="copiedper"
                    />
                    <span v-else>{{ textes.copy }}</span>
                  </button>

                  <!--font-awesome-icon @click="copie" icon="copy" class="icon-copy"/-->
                </div>
                <div class="link-data" v-if="embedUrl">
                  <p style=" font-weight: bold;">Embed</p>
                  <p class="link-p">{{ embedUrlData }}</p>
                  <input type="hidden" ref="linkEmbed" :value.sync="embedUrlData" />
                  <button
                    :class="['linkButton', { 'is-copied': copiedemb }]"
                    @click="copie('linkEmbed', 'embed')"
                  >
                    <font-awesome-icon
                      :icon="{ prefix: 'fas', iconName: 'check' }"
                      class=" check-icon"
                      v-if="copiedemb"
                    />
                    <span v-else>{{ textes.copy }}</span>
                  </button>

                  <!--font-awesome-icon @click="copie" icon="copy" class="icon-copy"/-->
                </div>
                <embed-code
                  :embedUrl="embedUrlData ? embedUrlData : embedCode"
                  :embedTitle="embedTitle"
                  :copyTitle="copyTitle"
                ></embed-code>
              </div>
              <!--</div>-->
              <div class=" items links interactions" v-show="listSocialMedia">
                <div class="text-partage-rx">
                  {{ textes.share_social }}
                </div>
                <div class="content-social">
                  <div class="content-social-icon">
                    <font-awesome-icon
                      :icon="{ prefix: 'fab', iconName: 'twitter-square' }"
                      class="icon-interactions twitter-icon"
                      @click="fireShareEvent('twitter')"
                    />
                    <font-awesome-icon
                      icon="envelope-square"
                      class="icon-interactions enveloppe-icon"
                      @click="fireShareEvent('email')"
                    />
                    <font-awesome-icon
                      :icon="{ prefix: 'fab', iconName: 'facebook' }"
                      class="icon-interactions facebook-icon"
                      @click="fireShareEvent('facebook')"
                    />
                    <font-awesome-icon
                      :icon="{ prefix: 'fab', iconName: 'linkedin' }"
                      class="icon-interactions linkedin-icon"
                      @click="fireShareEvent('linkedin')"
                    />
                    <font-awesome-icon
                      :icon="{ prefix: 'fab', iconName: 'youtube' }"
                      class="icon-interactions youtube-icon"
                      @click="fireShareEvent('youtube')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row-2">
          <font-awesome-icon
            icon="times"
            class=" icon-interactions share-icon "
            @click="toggleVisibility"
            style="float:right;"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../services/eventBus';
import LinkComponent from './LinkComponent.vue';
import IframeComponent from './IframeComponent.vue';
import EmbedCode from './EmbedCode.vue';
import Inteactions from './Interactions.vue';
import { Chrome } from 'vue-color';

export default {
  components: {
    'link-component': LinkComponent,
    'iframe-component': IframeComponent,
    'embed-code': EmbedCode,
    'interaction-component': Inteactions,
    'chrome-picker': Chrome,
  },
  name: 'modal-component',
  props: {
    uid: {
      type: String,
    },
    mp4: {
      type: Array,
    },
    telechargement: {
      type: String,
    },
    embedUrlPer: {
      type: String,
    },
    embedUrl: {
      type: String,
    },
    embedCode: {
      type: String,
    },
    isLive: {
      type: Boolean,
      default: false,
    },
    interactions: {
      type: Array,
      default: function() {
        return [];
      },
    },
    onShare: {
      type: Function,
    },
    visible: false,
    bgColor: {
      type: String,
    },
    element: {
      type: Function,
    },
    ShowMail: false,
    textes: {
      type: Object,
      default: () => ({
        integrations: 'Integrations',
        integrations_options: 'Integrations options',
        start_video_auto: 'Start playback automatically',
        default_color: 'Default color',
        start_at: 'Start at',
        share_social: 'Share on social networks',
        copy: 'copy',
        downloads: 'Downloads',
        embedTitle: 'embed code',
        permalink: 'Permalink',
      }),
    },
  },
  data() {
    return {
      embedUrlData: this.embedUrl,
      embedUrlDataPer: this.embedUrlPer,
      displayModal: this.visible,
      interactionsData: this.interactions,
      copyTitle: this.textes.copy,
      embedTitle: this.textes.embedTitle,
      listComponent: true,
      listSocialMedia: false,
      isActiveComponent: true,
      isActiveSocial: false,
      uidData: '',
      telechargementData: '',
      mp4Data: '',
      typeText: 'hidden',
      typeMp4: 'hidden',
      typeuid: 'hidden',
      typetel: 'hidden',
      autoPlay: false,
      color: '#000000',
      startAt: {
        sec: '',
        min: '',
      },
      form: {
        nom: '',
        mail: '',
        content: '',
      },
      btn: {
        display: 'inline-block',
        outline: 'none',
        background: 'red',
        margin: '2px',
        width: '48%',
        border: '0',
        borderRadius: '4px',
        padding: '12px 20px',
        color: '#fff',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        fontWeight: '500',
        lineHeight: 'inherit',
        textTransform: 'uppercase',
        cursor: 'pointer',
      },
      copieduid: false,
      copiedmp4: false,
      copiedtel: false,
      copiedper: false,
      copiedemb: false,
      displayPicker: false,
      colors: {
        hex: '#000000',
      },
    };
  },
  watch: {
    embedUrl: function(newVal) {
      this.embedUrlData = newVal;
    },
    embedUrlPer: function(newVal) {
      this.embedUrlDataPer = newVal;
    },
    interactions: function(newVal) {
      this.interactionsData = newVal;
    },
    visible: function(newVal) {
      this.displayModal = newVal;
    },
  },
  methods: {
    show() {
      this.displayModal = true;
      var body = document.querySelector('body');
      body.classList.add('modal-open');
    },
    toggleVisibility() {
      this.displayModal = false;
      var body = document.querySelector('body');
      body.classList.remove('modal-open');
    },
    copie(id, name) {
      var link = this.$refs[id];
      link.setAttribute('type', 'text');
      link.select();
      try {
        var successful = document.execCommand('copy');
        link.setAttribute('type', 'hidden');
      } catch (err) {
        console.log('unable to copy');
      }
      if (name == 'permalien') {
        this.copiedper = true;
      }
      if (name == 'embed') {
        this.copiedemb = true;
      }
      var self = this;
      setTimeout(function() {
        if (name == 'permalien') {
          self.copiedper = false;
        }
        if (name == 'embed') {
          self.copiedemb = false;
        }
      }, 1000);
    },

    fireShareEvent(social) {
      this.onShare(social);
    },
    openTab: function(list) {
      if (list == 'ListComponents') {
        this.listComponent = true;
        this.listSocialMedia = false;
        this.isActiveComponent = true;
        this.isActiveSocial = false;
      } else {
        this.listComponent = false;
        this.listSocialMedia = true;
        this.isActiveComponent = false;
        this.isActiveSocial = true;
      }
    },

    copyText(id, name) {
      var link = this.$refs[id];
      link.setAttribute('type', 'text');
      link.select();
      try {
        var successful = document.execCommand('copy');
        link.setAttribute('type', 'hidden');
      } catch (err) {
        console.log('unable to copy');
      }
      if (name == 'uid') {
        this.copieduid = true;
      }
      if (name == 'mp4') {
        this.copiedmp4 = true;
      }
      if (name == 'telechargement') {
        this.copiedtel = true;
      }

      var self = this;
      setTimeout(function() {
        if (name == 'uid') {
          self.copieduid = false;
        }
        if (name == 'mp4') {
          self.copiedmp4 = false;
        }
        if (name == 'telechargement') {
          self.copiedtel = false;
        }
      }, 1000);
    },
    updateEmbedCode() {
      this.color = this.colors.hex;
      var result = '';
      var n = 0;
      this.interactionsData.forEach(interaction => {
        if (interaction.value == 1) {
          result +=
            n == 0
              ? '?' + interaction.name + '=' + interaction.value
              : '&' + interaction.name + '=' + interaction.value;
          n++;
        }
      });

      this.embedUrlData = this.embedUrl;
      const startAt = +this.startAt.min * 60 + +this.startAt.sec;

      this.embedUrlData += '-' + (this.autoPlay ? '1' : '0');
      this.embedUrlData += '-' + this.color.substr(1);
      this.embedUrlData += '-' + startAt;

      this.embedUrlData = this.embedUrlData + result;
      this.embedUrlDataPer = this.embedUrlPer + result;
    },
    timeValidate(time) {
      const val = (+this.startAt[time]).toString();

      if (
        (time === 'min' && !/^\d{1,3}$/.test(val)) ||
        (time === 'sec' && !/^[0-5]?[0-9]?$/.test(val))
      ) {
        this.startAt[time] = 0;
      } else {
        this.startAt[time] = val;
      }
      this.updateEmbedCode();
    },
    closeModalExport(event) {
      console.log(event.target);
      if (event.target == event.currentTarget) {
        this.toggleVisibility();
      } else {
        event.stopPropagation();
      }
    },
  },
  computed: {
    modalVisible() {
      return this.displayModal;
    },
    mp4Text() {
      if (this.mp4) {
        return this.mp4
          .map(t => {
            return t.src + ' <br>';
          })
          .join();
      } else {
        return '';
      }
    },
  },
  created() {
    EventBus.$on('interaction-changed', e => {
      this.updateEmbedCode();
    });
  },
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}

.row-1 {
  float: var(--modal-export-row-1-float, left);
  width: var(--modal-export-row-1-width, 100%);
  /*padding: 5px; */
}
.row-2 {
  float: RIGHT;
  position: ABSOLUTE;
  right: 0;
  /*padding: 5px; */
}
.row-3 {
  float: var(--modal-export-row-3-float, left);
  width: var(--modal-export-row-3-width, 100%);
  /*padding: 5px; */
}
.column-1 {
  float: var(--modal-export-column-1-float, left);
  width: var(--modal-export-column-1-width, 63%);
  /*padding:   var(--modal-export-column-1-padding, 5px) ;*/
}
.column-2 {
  float: var(--modal-export-column-2-float, left);
  width: var(--modal-export-column-2-width, 37%);
  padding: var(--modal-export-column-2-padding, 0); /*0 1em*/
  /*height: 32vw;*/
  overflow: auto;
}

.modal-data:after {
  content: var(--modal-export-modal-data-after-content, '');
  clear: var(--modal-export-modal-data-after-clear, both);
  display: var(--modal-export-modal-data-after-display, table);
}
::-webkit-scrollbar {
  width: var(--modal-export-scroll-width, 2px);
}
/* Track */
::-webkit-scrollbar-track {
  background: var(--modal-export-scrollbar-track, #f1f1f1);
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--modal-export-scrollbar-thumb, #888);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: var(--modal-export-scrollbar-thumb-hover, #555);
}

.check-icon {
  width: var(--modal-check-icon-width, 20px);
  height: var(--modal-check-icon-height, 15px);
}

.is-copied {
  background: var(--modal-is-copied-background, #4db6ac !important);
  color: var(--modal-is-copied-color, #fff !important);
}

/* On screens that are 1100px wide or less, go from four columns to two columns */
@media screen and (max-width: 980px) {
  .column-2 {
    width: var(--modal-export-column-2-width, 100%);
  }
}

/* On screens that are 1100px wide or less, go from four columns to two columns */
@media screen and (max-width: 980px) {
  .column-1 {
    width: var(--modal-export-column-1-width, 100%);
  }
}

/* On screens that are 600px wide or less, make the menu links stack on top of each other instead of next to each other */
@media screen and (max-width: 500px) {
  .tab-data {
    float: var(--modal-export-tab-data-float, none);
    width: var(--modal-export-tab-data-width, 100%);
  }
}

p {
  padding: var(--modal-export-p-padding, 0px 5px);
  color: var(--modal-export-p-color, #404040);
}

.text-partage-rx {
  color: var(--modal-text-partage-rx-color, #74797f);
  font-size: var(--modal-text-partage-rx-font-size, 1vw);
  margin-left: var(--modal-text-partage-rx-margin-left, 2vw);
  text-align: var(--modal-text-partage-rx-text-align, left);
  margin-top: var(--modal-text-partage-rx-margin-top, 5vw);
  margin-bottom: var(--modal-text-partage-rx-margin-bottom, 1vw);
}
.content-social {
  background-color: var(--modal-content-social-background-color, #dadfe3);
  height: var(--modal-content-social-padding-height, 10vw);
  width: var(--modal-content-social-padding-width, 30vw);
  border-radius: var(--modal-content-social-border-radius, 3px);
  margin-left: var(--modal-content-social-margin-left, 2vw);
}

.content-social-icon {
  background-color: var(--modal-content-social-icon-background-color, white);
  margin: var(--modal-content-social-icon-margin, 1vw);
  border-radius: var(--modal-content-social-icon-border-radius, 3px);
}
.tab-data {
  overflow: var(--modal-export-tab-data-overflow, hidden);
  border-bottom: var(--modal-export-tab-data-border-bottom, 1px solid #ccc);
  margin-bottom: var(--modal-export-tab-data-margin-bottom, 20px);
}

/* Style the buttons that are used to open the tab content */
.tab-data button {
  background-color: var(--modal-export-tab-data-button-background-color, inherit);
  float: var(--modal-export-tab-data-button-float, left);
  border: var(--modal-export-tab-data-button-border, none);
  outline: var(--modal-export-tab-data-button-outline, none);
  cursor: var(--modal-export-tab-data-button-cursor, pointer);
  padding: var(--modal-export-tab-data-button-padding, 14px 16px);
  transition: var(--modal-export-tab-data-button-transition, 0.3s);
}

/* Change background color of buttons on hover */
.tab-data button:hover {
  background-color: var(--modal-export-tab-data-button-hover-background-color, #ddd);
}

/* Create an active/current tablink class */
.tab-data button.active {
  background-color: var(--modal-export-tab-data-button-active-background-color, #e6e6e6);
}

.link-data {
  display: var(--modal-export-link-data-display, flex);
  flex-direction: var(--modal-export-link-data-flex-direction, row);
  justify-content: var(--modal-export-link-data-justify-content, space-between);
  align-items: var(--modal-export-link-data-align-items, center);
  border-bottom: var(--modal-export-link-data-border-bottom, 1px solid rgba(144, 144, 144, 0.27));
  margin-bottom: var(--modal-export-link-data-margin-bottom, 10px);
}
@media screen and (max-width: 1200px) and (min-width: 981px) {
  .link-data {
    display: var(--modal-export-link-data-display, flex);
    flex-direction: var(--modal-export-link-data-flex-direction, column);
  }
}

@media screen and (max-width: 980px) {
  .link-data {
    display: var(--modal-export-link-data-display, flex);
    flex-direction: var(--modal-export-link-data-flex-direction, row);
  }
}
@media screen and (max-width: 576px) {
  .link-data {
    display: var(--modal-export-link-data-display, flex);
    flex-direction: var(--modal-export-link-data-flex-direction, column);
  }
}

.icon-interactions {
  width: var(--modal-export-icon-interactions-width, 15px);
  height: var(--modal-export-icon-interactions-height, 15px);
  color: var(--modal-export-icon-interactions-color, #909090);
  cursor: var(--modal-export-icon-interactions-cursor, pointer);
}
.icon-copy {
  width: var(--modal-export-icon-copy-width, 15px);
  height: var(--modal-export-icon-copy-height, 15px);
  color: var(--modal-export-icon-copy-color, #909090);
  cursor: var(--modal-export-icon-copy-cursor, pointer);
}
.partager {
  width: var(--modal-export-partager-width, 150px);
  height: var(--modal-export-partager-height, 30px);
  border: var(--modal-export-partager-border, none);
  border-radius: var(--modal-export-partager-border-radius, 5px);
  padding: var(--modal-export-partager-padding, 5px);
}

.items {
  display: var(--modal-export-items-display, inline-block);
  flex-direction: var(--modal-export-items-flex-direction, column);
  justify-content: var(--modal-export-items-justify-content, space-around);
  overflow: var(--modal-export-items-overflow, hidden);
}
.icons-nav {
  border-left: 1px solid hsla(0, 0%, 56.5%, 0.27);
}
.links {
  /*padding: 0 15px;*/
  width: var(--modal-export-links-width, 100%);
}

#modal-export {
  display: var(--modal-export-display, flex);
  flex-direction: var(--modal-export-flex-direction, row);
  justify-content: var(--modal-export-justify-content, space-between);
  align-items: var(--modal-export-align-items, center);
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}

.icon-interactions {
  width: var(--modal-export-icon-interactions-width, 40px);
  height: var(--modal-export-icon-interactions-height, 40px);
  color: var(--modal-export-icon-interactions-color, #888);
  margin: var(--modal-export-icon-interactions-margin, 10px);
  cursor: var(--modal-export-icon-interactions-cursor, pointer);
  padding: var(--modal-export-icon-interactions-padding, 10px 5px);
}
.facebook-icon {
  color: var(--modal-export-facebook-icon-color, #4267b2);
  height: var(--modal-export-facebook-icon-height, 4vw);
  width: var(--modal-export-facebook-icon-width, 4vw);
}
.twitter-icon {
  color: var(--modal-export-twitter-icon-color, #1da1f2);
  height: var(--modal-export-facebook-icon-height, 4vw);
  width: var(--modal-export-facebook-icon-width, 4vw);
}
.linkedin-icon {
  color: var(--modal-export-linkedin-icon-color, #0077b5);
  height: var(--modal-export-facebook-icon-height, 4vw);
  width: var(--modal-export-facebook-icon-width, 4vw);
}
.youtube-icon {
  color: var(--modal-export-youtube-icon-color, #ff0000);
  height: var(--modal-export-facebook-icon-height, 4vw);
  width: var(--modal-export-facebook-icon-width, 4vw);
}
.enveloppe-icon {
  height: var(--modal-export-facebook-icon-height, 4vw);
  width: var(--modal-export-facebook-icon-width, 4vw);
}
.share-icon {
  width: var(--modal-export-share-icon-width, 20px);
  /*height: 20px;*/
  color: var(--modal-export-share-icon-color, #888);
  /*margin: 5px;*/
  margin: var(--modal-export-share-icon-margin, 1px);
}
.interactions {
  display: var(--modal-export-interactions-display, flex);
  flex-wrap: var(--modal-export-interactions-flex-wrap, wrap);
  flex-direction: var(--modal-export-interactions-flex-direction, row);
  justify-content: var(--modal-export-interactions-justify-content, space-between);
  align-items: var(--modal-export-interactions-align-items, center);
  margin-bottom: var(--modal-export-interactions-margin-bottom, 25px);
}
.modal-data {
  background-color: var(--modal-component-bg-color, #fff);
  font-family: var(
    --modal-export-modal-data-font-family,
    'Open Sans',
    'Helvetica Neue',
    Helvetica,
    Arial,
    sans-serif
  );
  height: var(--modal-export-modal-data-height, 32vw);
  width: var(--modal-export-modal-data-width, 90vw);
  border-radius: var(--modal-export-modal-data-border-radius, 2px);
  text-align: var(--modal-export-modal-data-text-align, center);
  position: var(--modal-export-modal-data-position, absolute);
  left: var(--modal-export-modal-data-left, 31%);
  top: var(--modal-export-modal-data-top, 50%);
  margin-left: var(--modal-export-modal-data-margin-left, -26vw);
  margin-top: var(--modal-export-modal-data-margin-top, -33vh);
  overflow: var(--modal-export-modal-data-overflow, hidden);
  z-index: var(--modal-export-modal-data-z-index, 99999);
  -webkit-animation-duration: var(--modal-export-modal-data--webkit-animation-duration, 0.5s);
  animation-duration: var(--modal-export-modal-data-animation-duration, 0.5s);
  margin-bottom: 40px;
}

/* On screens that are 980px wide or more, go from four columns to two columns */
@media screen and (min-width: 980px) {
  /* min-width :980px ------> 1200px */

  .modal-data {
    height: var(--modal-export-modal-data-height, 32vw);
    margin-top: var(--modal-export-modal-data-margin-top, -33vh);
    overflow-x: hidden;
    overflow-y: auto;
  }
}

@media screen and (max-width: 1703px) and (min-width: 980px) {
  /* min-width :980px ------> 1200px */
  .modal-data {
    height: var(--modal-export-modal-data-height, 32vw);
    margin-top: var(--modal-export-modal-data-margin-top, -33vh);
    overflow-x: hidden;
    overflow-y: auto;
  }
  .facebook-icon {
    color: var(--modal-export-facebook-icon-color, #4267b2);
    height: var(--modal-export-facebook-icon-height, 4vw);
    width: var(--modal-export-facebook-icon-width, 3vw);
  }
  .twitter-icon {
    color: var(--modal-export-twitter-icon-color, #1da1f2);
    height: var(--modal-export-twitter-icon-height, 4vw);
    width: var(--modal-export-twitter-icon-width, 3vw);
  }
  .linkedin-icon {
    color: var(--modal-export-linkedin-icon-color, #0077b5);
    height: var(--modal-export-linkedin-icon-height, 4vw);
    width: var(--modal-export-linkedin-icon-width, 3vw);
  }
  .youtube-icon {
    color: var(--modal-export-youtube-icon-color, #ff0000);
    height: var(--modal-export-youtube-icon-height, 4vw);
    width: var(--modal-export-youtube-icon-width, 3vw);
  }
  .enveloppe-icon {
    height: var(--modal-export-enveloppe-icon-height, 4vw);
    width: var(--modal-export-enveloppe-icon-width, 3vw);
  }
}
@media screen and (max-width: 980px) {
  /* max-width :980px ------> 1200px */

  .modal-data {
    height: var(--modal-export-modal-data-height, auto); /*105vw*/
    margin-top: var(--modal-export-modal-data-margin-top, -44vh);
    overflow-y: var(--modal-export-modal-data-overflow-y, auto);
  }
  .content-social {
    background-color: var(--modal-content-social-background-color, #dadfe3);
    height: var(--modal-content-social-padding-height, 16vw);
    width: var(--modal-content-social-padding-width, 54vw);
    border-radius: var(--modal-content-social-border-radius, 3px);
    margin-left: var(--modal-content-social-margin-left, 2vw);
  }

  .content-social-icon {
    background-color: var(--modal-content-social-icon-background-color, white);
    margin: var(--modal-content-social-icon-margin, 1vw);
    border-radius: var(--modal-content-social-icon-border-radius, 3px);
  }
  .text-partage {
    color: var(--modal-text-partage-color, #52575b);
    font-size: var(--modal-text-partage-font-size, 2vw);
    text-align: var(--modal-text-partage-text-align, left);
    margin: var(--modal-text-partage-margin, 1vw);
    padding-top: var(--modal-text-partage-padding-top, 1vw);
  }
  .text-partage-rx {
    color: var(--modal-text-partage-rx-padding-top, #74797f);
    font-size: var(--modal-text-partage-rx-padding-top, 2vw);
    margin-left: var(--modal-text-partage-rx-padding-top, 2vw);
    text-align: var(--modal-text-partage-rx-padding-top, left);
    margin-top: var(--modal-text-partage-rx-padding-top, 6vw);
    margin-bottom: var(--modal-text-partage-rx-padding-top, 1vw);
  }
  .facebook-icon {
    color: var(--modal-export-facebook-icon-color, #4267b2);
    height: var(--modal-export-facebook-icon-height, 6vw);
    width: var(--modal-export-facebook-icon-width, 5vw);
  }
  .twitter-icon {
    color: var(--modal-export-twitter-icon-color, #1da1f2);
    height: var(--modal-export-twitter-icon-height, 6vw);
    width: var(--modal-export-twitter-icon-width, 5vw);
  }
  .linkedin-icon {
    color: var(--modal-export-linkedin-icon-color, #0077b5);
    height: var(--modal-export-linkedin-icon-height, 6vw);
    width: var(--modal-export-linkedin-icon-width, 5vw);
  }
  .youtube-icon {
    color: var(--modal-export-youtube-icon-color, #ff0000);
    height: var(--modal-export-youtube-icon-height, 6vw);
    width: var(--modal-export-youtube-icon-width, 5vw);
  }
  .enveloppe-icon {
    height: var(--modal-export-enveloppe-icon-height, 6vw);
    width: var(--modal-export-enveloppe-icon-width, 5vw);
  }
}

p {
  font-size: var(--modal-export-p-font-size, 15px);
  text-align: var(--modal-export-p-text-align, center);
  font-weight: var(--modal-export-p-font-weight, 300);
  position: var(--modal-export-p-position, relative);
  text-align: var(--modal-export-p-text-align, inherit);
  float: var(--modal-export-p-float, none);
  margin: var(--modal-export-p-margin, 0);
  padding: var(--modal-export-p-padding, 5px);
  line-height: var(--modal-export-p-line-height, normal);
}
.modal-overlay {
  position: var(--modal-export-modal-overlay-position, fixed);
  z-index: var(--modal-export-modal-overlay-z-index, 9998);
  top: var(--modal-export-modal-overlay-top, 0);
  left: var(--modal-export-modal-overlay-left, 0);
  width: var(--modal-export-modal-overlay-width, 100%);
  height: var(--modal-export-modal-overlay-height, 100%);
  background-color: var(--modal-export-modal-overlay-background-color, rgba(0, 0, 0, 0.5));
  transition: var(--modal-export-modal-overlay-transition, opacity 0.3s ease);
  overflow-x: hidden;
  overflow-y: auto;
  transform: translate(0, 0);
  outline: 9999px solid rgba(0, 0, 0, 0.5);
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: var(--modal-export-modal-leave-active--webkit-transform, scale(1.1));
  transform: var(--modal-export-modal-leave-active-transform, scale(1.1));
}

.linkButton {
  background-color: var(--modal-export-link-button-background-color, #f0f0f0); /* Grey */
  border: var(--modal-export-link-button-border, none);
  color: var(--modal-export-link-button-color, #8d8d8d);
  padding: var(--modal-export-link-button-padding, 10px 25px);
  text-align: var(--modal-export-link-button-text-align, center);
  text-decoration: var(--modal-export-link-button-text-decoration, none);
  display: var(--modal-export-link-button-display, inline-block);
  font-size: var(--modal-export-link-button-font-size, 13px);
  margin: var(--modal-export-link-button-margin, 4px 2px);
  -webkit-transition-duration: var(
    --modal-export-link-button--webkit-transition-duration,
    0.4s
  ); /* Safari */
  transition-duration: var(--modal-export-link-button-transition-duration, 0.4s);
  cursor: var(--modal-export-link-button-cursor, pointer);
  border-radius: var(--modal-export-link-button-border-radius, 5px);
}
@media screen and (max-width: 1200px) and (min-width: 981px) {
  .linkButton {
    margin: 0 10px 10px !important;
    width: var(--modal-export-link-button-width, 100%);
  }
}
@media screen and (max-width: 980px) {
  .linkButton {
    margin: var(--modal-export-link-button-margin, 4px 2px !important);
    width: var(--modal-export-link-button-width, auto);
  }
}
@media screen and (max-width: 576px) {
  .linkButton {
    margin: 0 10px 10px !important;
    width: var(--modal-export-link-button-width, 100%);
  }
}
.link-interaction {
  border-bottom: var(
    --modal-export-link-interaction-border-bottom,
    1px solid rgba(144, 144, 144, 0.27)
  );
  margin-bottom: var(--modal-export-link-interaction-margin-bottom, 10px);
}
.link-p {
  width: var(--modal-export-link-p-width, 19vw);
  word-break: var(--modal-export-link-p-word-break, break-all);
}
@media screen and (max-width: 1200px) and (min-width: 981px) {
  .link-p {
    width: var(--modal-export-link-p-width, 100%);
    word-break: var(--modal-export-link-p-word-break, break-all);
  }
}
@media screen and (max-width: 980px) {
  .link-p {
    width: var(--modal-export-link-p-width, 19vw);
    word-break: var(--modal-export-link-p-word-break, break-all);
  }
}

@media screen and (max-width: 576px) {
  .link-p {
    width: var(--modal-export-link-p-width, 100%);
    word-break: var(--modal-export-link-p-word-break, break-all);
  }
}

/* For mobile phones: */
[class*='col-'] {
  width: 100%;
}

.auto-play-container .link-p,
.color-container .link-p,
.start-at-container .link-p {
  width: auto !important;
  flex-shrink: 0;
}

.toggle-switch-container .switch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 20px;
  margin: 8px 0;
}
.toggle-switch-container .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.toggle-switch-container .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  height: 20px;
}
.toggle-switch-container .slider:before {
  position: absolute;
  content: '';
  height: 16px;
  width: 16px;
  left: 2px;
  top: 2px;
  background-color: white;
  transition: 0.4s;
}
.toggle-switch-container .slider.round {
  border-radius: 10px;
}
.toggle-switch-container .slider.round:before {
  border-radius: 50%;
}
.toggle-switch-container input:checked + .slider {
  background-color: #2196f3;
}
.toggle-switch-container input:checked + .slider:before {
  transform: translateX(22px);
}

input[type='color'] {
  -webkit-appearance: none;
  border: none;
}
input[type='color']::-webkit-color-swatch-wrapper {
  padding: 0;
}
input[type='color']::-webkit-color-swatch {
  border: none;
}

.time-input {
  font-size: 14px;
  text-align: center;
  height: fit-content;
  height: -moz-fit-content;
  max-width: 50px;
  height: 32px;
  margin: 0 2px 0 15px;
  border: 1px solid #d1d1d1;
  border-radius: 2px;
}
.bg-color-area {
  width: 28px;
  height: 28px;
  margin-bottom: 5px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ {
  .vc-chrome {
    font-family: Arial;
    position: absolute;
    right: 16px;
    z-index: 1;
  }
  .vc-input__label {
    display: none !important;
  }
  .vc-chrome-toggle-btn {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/modal-export/src/components/Component.vue